/// <reference path="Assistant.ts" />

namespace TerminalApp {
    function generateDateBasedNumber() {
        const date = new Date();
        const year = date.getFullYear().toString().slice(-2); // Last two digits of the year
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based, so +1
        const day = date.getDate().toString().padStart(2, '0');
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');

        return `${year}${month}${day}${hours}${minutes}${seconds}`;
    }

    class ProductionElement {
        container = document.createElement("div");
        batch_input: HTMLInputElement;
        quantity_input: HTMLInputElement;
        expiration_container: HTMLElement;
        expiration_input: HTMLInputElement;
        item_headline: HTMLElement;
        image_contianer: HTMLElement;
        order: SP.OrderInfo;
        item: SP.ItemInfo;

        constructor(data: SP.ProductionOrderInfo, number: number) {
            this.order = data.order;
            this.item = data.item;
            //build html
            this.container.innerHTML = `
                <div class="setting_group setting_group-custom" style='margin-top:20px'>
                    <div class="setting-custom">
                    <div class="tote">${data.toteName}</div>
                    <div class="image_container" style="text-align:center">
                        <img src="${this.item.imageUrl}" style='max-width:200px; max-height:200px;' />
                    </div>
                    <h2 class='item_headline' style="color:gray">${this.item.description}</h2>
                        <div class="terminal-form-input-container">
                        <b>${SP.Localize("word_quantity")} ${SP.Localize("word_produced")}</b>
                            <input class="terminal-form-input el_qty" value="${this.order.collectionOrderQty}" type="number" placeholder="${SP.Localize("word_quantity")}" />
                        </div>

                        <div class="terminal-form-input-container el_expiration_container">
                        <b>${SP.Localize("word_expiration")}</b>
                            <input class="terminal-form-input el_expiration" type="date" placeholder="${SP.Localize("word_expiration")}" />
                        </div>

                        <div class="terminal-form-input-container">
                        <b>${SP.Localize("word_batch")}</b>
                            <input class="terminal-form-input el_batch" type="text" placeholder="${SP.Localize("word_batch")}" />
                        </div>
                        <div class='barcodes'></div>
                    </div>
                </div>
            `;

            //set references
            var barcodes = this.container.querySelector(".barcodes");
            this.item_headline = this.container.querySelector(".item_headline");
            this.image_contianer = this.container.querySelector(".image_container");
            this.batch_input = this.container.querySelector(".el_batch");
            this.quantity_input = this.container.querySelector(".el_qty");
            this.expiration_input = this.container.querySelector(".el_expiration");
            this.expiration_container = this.container.querySelector(".el_expiration_container");
            this.expiration_container.style.display = this.item.expirable ? "block" : "none";

            this.image_contianer.addEventListener("click", () => {
                TerminalApp.itemShortcutAssistant.open_with_info(this.item);
            });

            if (App_Settings.userSettings.autogenerate_production_batch_number) {
                this.batch_input.value = generateDateBasedNumber() + "-" + number;
            }

            if (this.item.allBarcodes) {
                for (var bc in this.item.allBarcodes) {
                    var qty = this.item.allBarcodes[bc];
                    var printBtn = document.createElement("div");

                    printBtn.classList.add("btn", "noselect", "grad-gray");
                    printBtn.innerHTML = `<span class="action"><i class='fas fa-print'></i> ${bc} `;

                    if (qty > 1) {
                        printBtn.innerHTML += `(colli: ${qty})`;
                    }

                    printBtn.addEventListener("click", async () => {
                        var amt = parseInt(prompt(SP.Localize("sentance_enter_amount"), "1"));
                        if (amt) {
                            var result = await SP.get<any>(`/api/v1/item/printbarcode?printer=${App_Settings.terminalSettings.etiquette_printer}&id=${this.item.id}&barcode=${encodeURIComponent(bc)}&colli=${qty}&copies=${amt}`);
                            if (result.status != 200) await SP.alertX(result.msg);
                        }
                    });
                    barcodes.appendChild(printBtn);
                }
            }
            this.item.allBarcodes
        }

        getProductionData() {
            return {
                orderId: this.order.orderId,
                quantity: this.quantity_input.value,
                expirationDate: this.expiration_input.value,
                batchNumber: this.batch_input.value
            };
        }
    } 

    export class FinishProductionAssistant extends Assistant {
        order_container = document.createElement("div");
        orders: ProductionElement[] = [];
        current: SP.StockingLotInfo;

 
        constructor() {
            super();
            var headline = document.createElement("h1");
            headline.innerHTML = SP.Localize("sentance_finish_production");

            var finishButton = document.createElement("div");
            finishButton.classList.add("btn", "noselect", "grad-green");
            finishButton.innerHTML = `<span class="action">${SP.Localize("sentance_finish_production")}</span>`;
            finishButton.addEventListener("click", async () => {
                SP.Sounds.Click.play();
                this.resolveOnClose(this.orders.map(o => o.getProductionData())); // This line has no TypeScript errors now
                this.close();
            });
            

            this.container.appendChild(headline);
            this.container.appendChild(this.order_container);
            this.container.appendChild(finishButton);
        }


        resolveOnClose: (data: any) => void;

        async open(orders: SP.ProductionOrderInfo[]) {
            this.reset();

            for (var i = 0; i < orders.length; i++) {
                var order = new ProductionElement(orders[i], i+1);
                this.orders.push(order);
                this.order_container.appendChild(order.container);
            }

    
            this.container.style.display = "block";

            // Promise is created only for the close operation.
            return new Promise<any>((resolve, reject) => {
                this.resolveOnClose = resolve;
            });
        }

        close() {
            // When close is called, resolve the Promise.
            if (this.resolveOnClose) {
                this.resolveOnClose(null);
            }
            super.close();
        }

        reset() {
            this.orders = [];
            this.order_container.innerHTML = '';
        }

    }
}